// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-filter__filter-input-item {
  width: 200px;
}
.dl-dialog-filter__delete-button {
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogFilter/InputFilter/InputFilter.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":[".dl-dialog-filter__filter-input-item {\n  width: 200px;\n}\n.dl-dialog-filter__delete-button {\n  margin-left: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
